import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import device_lib from './modules/device_lib'

Vue.use(Vuex)

//页面刷新用户信息丢失
//信息直接从localStorage获取
let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {}
// userInfo = JSON.parse(userInfo)

export default new Vuex.Store({
  state: {
      //vuex定义用户信息
      userInfo,
      //面包屑
      crumb:[],
      //云id
      cloudId: null,
      module_params_list: [],
  },
  mutations: {
      //更改userInfo
      SET_USERINFO(state,payload){
          state.userInfo = payload
      },
      //更改面包屑
      SET_CRUMB(state,payload){
        this.state.crumb = payload
      },
      //更改云id
      SET_CLOUDID(state,payload){
        this.state.cloudId = payload
      },
      //
      SET_MODULE_PARAMS_LIST(state,payload){
        this.state.module_params_list = payload
      }
  },
  actions: {

  },
  modules: {
    device_lib
  },
  getters
})


// WEBPACK FOOTER //
// ./src/store/index.js